export default __webpack_public_path__ + "static/media/A2_31.d48b67c2.mp3";